export const styles = {
  page: (isMobile) => ({
    flex: 1,
    minWidth: 0,
    minHeight: "100vh",
    overflowY: "auto",
    boxSizing: "border-box",
    padding: isMobile ? 18 : 28,
    background: "linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%)",
  }),
  backButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 36,
    height: 36,
    padding: 0,
    marginRight: 10,
    border: "none",
    borderRadius: 10,
    background: "transparent",
    color: "#1f3a70",
    cursor: "pointer",
  },
  card: (isMobile) => ({
    width: "100%",
    padding: isMobile ? 20 : 28,
    boxSizing: "border-box",
    background: "#fff",
    border: "1px solid #e3eaf5",
    borderRadius: 22,
    boxShadow: "0 20px 50px rgba(34, 60, 80, 0.08)",
    border: "1px solid rgba(31, 58, 112, 0.08)",
  }),
  headerRow: (isMobile) => ({ display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: isMobile ? "flex-start" : "center", gap: isMobile ? 10 : 14, marginBottom: 24 }),
  iconBadge: { width: 48, height: 48, display: "grid", placeItems: "center", borderRadius: 14, color: "#fff", background: "linear-gradient(135deg, #1f3a70, #3d5bb8)", boxShadow: "0 16px 32px rgba(31, 58, 112, 0.14)" },
  headerText: { minWidth: 0 },
  title: { margin: 0, fontSize: 22, color: "#1f3a70" },
  subtitle: { margin: "6px 0 0", fontSize: 14, color: "#5d6f8a", lineHeight: 1.5 },
  sectionHeader: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: 14, marginBottom: 24 },
  statusReadOnly: (status) => {
    const palettes = {
      aberto: { background: "#fff6df", color: "#805700", border: "#f1d590" },
      "em andamento": { background: "#e9f2ff", color: "#2456a6", border: "#c8dcfb" },
      pendente: { background: "#fff1e5", color: "#9a4e10", border: "#f3d0b3" },
      concluido: { background: "#e7f6ee", color: "#17663d", border: "#c3e6d1" },
      rejeitado: { background: "#fff0ef", color: "#a3312a", border: "#f1cbc8" },
    };
    const palette = palettes[status] || { background: "#eef2f5", color: "#435466", border: "#d9e1e7" };

    return {
      display: "inline-flex",
      alignItems: "center",
      gap: 7,
      flexShrink: 0,
      padding: "8px 12px",
      border: `1px solid ${palette.border}`,
      borderRadius: 999,
      background: palette.background,
      color: palette.color,
      fontSize: 13,
      fontWeight: 700,
      boxShadow: "0 2px 5px rgba(28, 45, 60, 0.05)",
    };
  },
  cardTitle: { margin: 0, fontSize: 18, color: "#15233c" },
  cardDescription: { margin: "8px 0 0", color: "#6a7c96", fontSize: 14, lineHeight: 1.55, whiteSpace: "pre-wrap" },
  form: { display: "flex", flexDirection: "column" },
  formGroup: { width: "100%", display: "flex", flexDirection: "column", gap: 10, marginBottom: 18 },
  startButton: { width: "100%", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 18, padding: "14px 18px", border: "none", borderRadius: 16, background: "linear-gradient(135deg, #1f3a70, #3d5bb8)", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 16px 30px rgba(31, 58, 112, 0.18)" },
  rejectButton: { background: "#b91c1c", boxShadow: "0 10px 24px rgba(185, 28, 28, 0.16)" },
  completeButton: { background: "#15803d", boxShadow: "0 10px 24px rgba(21, 128, 61, 0.16)" },
  assumingSpinner: { width: 16, height: 16, flex: "0 0 16px", borderRadius: "50%", border: "2px solid rgba(255, 255, 255, 0.4)", borderTopColor: "#fff", animation: "ticketMessagesSpin 0.8s linear infinite" },
  label: { color: "#48627a", fontSize: 13, fontWeight: 600 },
  input: { width: "100%", minHeight: 46, padding: "12px 14px", borderRadius: 16, border: "1px solid rgba(31, 58, 112, 0.14)", fontSize: 14, color: "#223047", outline: "none", boxSizing: "border-box" },
  selectStyles: {
    control: (base) => ({ ...base, minHeight: 46, borderRadius: 16, borderColor: "rgba(31, 58, 112, 0.14)", boxShadow: "none", fontSize: 14 }),
    menu: (base) => ({ ...base, zIndex: 20 }),
    menuList: (base) => ({ ...base, maxHeight: 180, overflowY: "auto", padding: 4 }),
    option: (base, state) => ({ ...base, backgroundColor: state.isFocused ? "#eef2ff" : "#fff", color: "#223047" }),
  },
  optionLabel: { display: "flex", alignItems: "center", gap: 8 },
  optionImage: { width: 26, height: 26, borderRadius: "50%", objectFit: "cover" },
  textarea: { width: "100%", minHeight: 140, padding: "14px 16px", borderRadius: 18, border: "1px solid rgba(31, 58, 112, 0.14)", fontSize: 14, color: "#223047", resize: "vertical", outline: "none", boxSizing: "border-box", lineHeight: 1.6 },
  error: { padding: "10px 12px", borderRadius: 10, background: "#fee2e2", color: "#b91c1c", fontSize: 13 },
  success: { display: "flex", alignItems: "center", gap: 7, padding: "10px 12px", borderRadius: 10, background: "#dcfce7", color: "#166534", fontSize: 13 },
  saveButton: { width: "100%", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 6, padding: "14px 18px", border: "none", borderRadius: 16, background: "linear-gradient(135deg, #1f3a70, #3d5bb8)", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 16px 30px rgba(31, 58, 112, 0.22)" },
  supportSection: { margin: "24px 0", padding: "20px 0", borderTop: "1px solid #e6ebf0", borderBottom: "1px solid #e6ebf0" },
  supportHeader: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 14 },
  supportDescription: { margin: "5px 0 0", color: "#718096", fontSize: 13, lineHeight: 1.45 },
  supportBadge: { flexShrink: 0, padding: "5px 9px", borderRadius: 6, background: "#fff4d6", color: "#815b00", fontSize: 11, fontWeight: 700 },
  supportMessages: { display: "flex", flexDirection: "column", gap: 10, maxHeight: 240, overflowY: "auto", padding: 12, borderRadius: 8, background: "#f5f8fa" },
  loadingMessagesContainer: { display: "flex", alignItems: "center", justifyContent: "center", gap: 10, minHeight: 120, padding: 20, borderRadius: 12, background: "#f5f8fa", color: "#49627e" },
  loadingMessagesSpinner: { width: 20, height: 20, borderRadius: "50%", border: "3px solid rgba(31, 58, 112, 0.14)", borderTopColor: "#1f3a70", animation: "ticketMessagesSpin 0.8s linear infinite" },
  loadingMessagesText: { fontSize: 13, fontWeight: 600, color: "#49627e" },
  responsibleGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12, margin: "16px 0 10px" },
  responsibleCard: { display: "flex", flexDirection: "column", gap: 6, padding: "12px 14px", borderRadius: 12, border: "1px solid #e2eaf4", background: "#f8fbff" },
  responsibleLabel: { fontSize: 11, letterSpacing: "0.06em", textTransform: "uppercase", color: "#6d7d93" },
  responsibleValue: { fontSize: 15, color: "#1d2d3d" },
  supportMessageRow: (sender) => ({ display: "flex", justifyContent: sender === "support" ? "flex-end" : "flex-start" }),
  supportBubble: (sender) => ({ maxWidth: "82%", padding: "10px 12px", borderRadius: 8, background: sender === "support" ? "#e4f3ef" : "#fff", border: `1px solid ${sender === "support" ? "#cde5dc" : "#e3e9ee"}`, overflowWrap: "anywhere" }),
  supportSender: { display: "block", marginBottom: 4, color: "#405267", fontSize: 12 },
  supportMessageText: { margin: 0, color: "#263747", fontSize: 13, lineHeight: 1.5, whiteSpace: "pre-wrap" },
  supportMessageImage: { display: "block", maxWidth: "100%", maxHeight: 320, marginTop: 6, borderRadius: 8, objectFit: "contain" },
  supportComposer: { display: "flex", gap: 8, marginTop: 10, alignItems: "flex-end" },
  supportInput: { flex: 1, minWidth: 0, minHeight: 80, padding: "10px 12px", border: "1px solid #d7e0e7", borderRadius: 8, outline: "none", color: "#223047", fontSize: 13, boxSizing: "border-box", resize: "vertical" },
  supportSendButton: { display: "inline-flex", alignItems: "center", justifyContent: "center", width: 42, height: 42, border: "none", borderRadius: 8, background: "#176b62", color: "#fff", cursor: "pointer" },
  supportNote: { margin: "8px 0 0", color: "#778596", fontSize: 11, lineHeight: 1.4 },
};
